function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 62,
  r: 60.5,
  stroke: "#2E4F70",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2697 48.0787H89V61.4495M73.2697 48.0787V41H57.5393V48.0787M73.2697 48.0787H57.5393M57.5393 48.0787H41.809C41.809 49.7324 41.809 52.4727 41.809 55.1573M89 61.4495V82.6854H41.809L41.809 69.3146M89 61.4495C89 62.7544 87.0382 65.7737 82.7079 66.9551M73.2697 66.9551C73.2697 66.9551 71.6966 66.9551 57.5393 66.9551M54.3932 66.9551H46.5281C44.955 66.4307 41.809 64.5955 41.809 61.4495M41.809 61.4495C41.809 60.2833 41.809 58.5767 41.809 56.7304M41.809 61.4495L41.809 67.7416M57.5393 64.5955V69.3146M73.2697 64.5955V69.3146M82.7079 66.9551C81.1348 66.9551 77.4473 66.9551 75.6292 66.9551H82.7079ZM40.236 55.9438H26.0787M37.8764 62.236H19M38.6629 68.5281H26.0787",
  stroke: "#2E4F70",
  strokeWidth: 3
});

function SvgProjectDevliery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDevliery);
export default __webpack_public_path__ + "static/media/ProjectDevliery.3253617b.svg";
export { ForwardRef as ReactComponent };